import { Grid, Box, List, ListItem, FormGroup, IconButton, Paper, TextField, Typography, Button, Label} from "@material-ui/core"
import { makeStyles, StylesProvider } from '@material-ui/core/styles';
import io from 'socket.io-client';
import { useState, useEffect, useRef } from "react";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  startchat,
  getchatbydate,
  listTripbyNumber2,
  searchCustomersbyNumber,
  getchat24,
  gmailSend,
  updatereadflag
} from "../api/customerapi";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import {url as serverurl, uploadsinglefile} from "../api/customerapi.js"


const socket = io(serverurl);

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
      marginTop: theme.spacing(10),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    image:{
        width:"200px",
        height:"200px",
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      selectdiv:{
        cursor: "pointer",
        color: "black", 
       "&:hover": {
            color: "green", // Color change on hover
        },
        width: "100%",
      },
      selectdiv2:{
        cursor: "pointer", 
        color: "red",
       "&:hover": {
            color: "green", // Color change on hover
        },
        width: "100%",
      }
  }));

const Chat = () => {
    const classes = useStyles();
    const { cuser, role } = GetRole();
    const [chatData, setchatData]=useState(null)
    const [selectedchat, setselectedchat]=useState(null)
    const [initiatechat, setinitiatechat]=useState(null)
    const inputRef = useRef(null);
    const [input, setinput]=useState("")
    const messagesEndRef = useRef(null);
    const scrollableBoxRef = useRef(null);
    const [finalfiledetails, setfinalfiledetails] = useState([]);
    const [filedetails, setfiledetails] = useState([]);

    const loadchats=async() => {
      const data=await getchat24()
      setchatData(data.data)
      if(data.data.length>0){
      setselectedchat({...data.data[0], agent_read_flag: true})
      }
      console.log(data.data)
    }
     
  useEffect(() => {
      loadchats()

      if (inputRef.current) {
        inputRef.current.focus();
      }
  
      const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          document.getElementById('myButton').click();
           // Programmatically click the button
          //  scrollableDiv.scrollTop = scrollableDiv.scrollHeight+100;
        }
      };
  
      // Attach the event listener
      document.addEventListener('keydown', handleKeyDown);
  
      // Cleanup the event listener when the component unmounts
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
      
   }, []);

   const scrollToBottom = () => {
    const box = scrollableBoxRef.current;
    console.log(box.scrollHeight)
    if (box) {
      box.scrollTop = box.scrollHeight;
    }
  };

   useEffect(() => {

    const changechatstate=(data)=>{
      // console.log(data)
      setselectedchat((prevState) => {
        console.log('Previous State:', prevState);
        if(prevState.primary_mobile_number==data.sender){
        return {...prevState, messages:[...prevState.messages,data], agent_read_flag:true}
        }else{
          return prevState
        }; // Update logic based on data
      });
      setchatData((prevState) => {
        return prevState.map(c=>c.primary_mobile_number==data.sender?{...c, messages:[...c.messages,data], agent_read_flag:true}:c)
      })
    }
 

    socket.on(`messageAgent:`, changechatstate)

 
  }, []); 
 
  useEffect(() => {
    if(scrollableBoxRef.current){
      scrollableBoxRef.current.scrollTop=scrollableBoxRef.current.scrollHeight
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    
  }, [selectedchat]);

const uploadmultifile=async()=>{
  console.log(filedetails)
  var tempfiledetails=[...finalfiledetails]
  try{
    for(let i=0;i<filedetails.length;i++){
      const data=await uploadsinglefile(filedetails[i].file)
      console.log(data.data)
      if(data.data.name){
        alert("File "+data.data.name+" uploaded succesfully")
      }else{
        alert("Error while uploading")
      }
      const temp={
        location:data.data.location,
        name:data.data.name,
      }
      tempfiledetails=[...tempfiledetails, temp]
      
    }
    setfinalfiledetails(tempfiledetails)
    socket.emit('send-message', { sender: selectedchat.primary_mobile_number, sender_type: 'Agent '+cuser, content: input, createdAt:new Date(),fileUrl:tempfiledetails });
    setinput('');
    setfiledetails([])
   console.log(tempfiledetails)
  }catch(e){
    console.log(e)
  }
}

   const changechat=async(c)=>{
    setselectedchat({...chatData[c],agent_read_flag:true})
    setchatData(chatData.map(ch=>chatData.indexOf(ch)==c?{...ch, agent_read_flag:true}:ch))
    const data=await updatereadflag(chatData[c]._id)
   }

   const sendmessage=async()=>{
    if(filedetails.length > 0){
      uploadmultifile()
    }
    if(input!==""){
    socket.emit('send-message', { sender: selectedchat.primary_mobile_number, sender_type: 'Agent '+cuser, content: input, createdAt:new Date() });
    setinput('');
     let from="care@jetovacations.com"
     
       let subject="New Message from Jeto Vacations-Important"
        let body="You have got a new chat message. Click the link below to view the message:\n\n"+"https://www.jetovacations.com/chat?"+9755205876
    // if(selectedchat.length==0){
    //   const data=await listTripbyNumber2(selectedchat.primary_mobile_number)
    //   if(data.data.length>0 && data.data[0].primary_email_id){
    //     let to=data.data[0].primary_email_id
    //       gmailSend(from, to, subject, body)
    //   }
    // }else if(selectedchat.length>0 && ((new Date().getTime() - new Date(selectedchat.messages[selectedchat.messages.length-1].createdAt).getTime())>(1000*60*30))){
    //   const data=await listTripbyNumber2(selectedchat.primary_mobile_number)
    //   if(data.data.length>0 && data.data[0].primary_email_id){
    //     let to=data.data[0].primary_email_id
    //       gmailSend(from, to, subject, body)
    //   }
    // }
    }
   }

   const handleFileInput2 = (e) => {
    //console.log(e)
   
    var tempfile=filedetails.length>0?[...filedetails]:[]
    console.log(tempfile)
    for(let i=0;i<e.target.files.length;i++){
      const formdata=new FormData()
      formdata.append("myFile",e.target.files[i],e.target.files[i].name)
      const temp={
        file:formdata,

      }
      tempfile=[...tempfile, temp]
    }
    console.log(tempfile)
    setfiledetails(tempfile)
  
    // const formdata=new FormData()
    // formdata.append("myFile",e.target.files[0],e.target.files[0].name)
    // setfiledetails({...filedetails, file:formdata});
  }

  const initiatechatwithcust=async()=>{
    if(initiatechat){
    const data=await searchCustomersbyNumber(initiatechat)
    if(data.data.length>0){
    const temp={
      cust_name: data.data[0].cust_name,
      cust_id: data.data[0].cust_id,
      primary_mobile_number:data.data[0].primary_mobile_number,
      primary_email_id:data.data[0].primary_email_id,
      agent_read_flag: true,
      messages: [
        {
          sender: data.data[0].primary_mobile_number.toString(),
          sender_type:"Agent "+cuser, // 'customer' or 'agent'
          content: "New chat initiated",
        },
      ],
  }
    setchatData([...chatData, temp])
  }else{
    alert("Customer not found")
  }
  }else{
    alert("Enter phone number of customer")
  }
  }

  console.log(chatData)

    return (
        <Paper variant="outlined" className={classes.paper} elevation={10}  >
        <FormGroup row className={classes.formgroup}>
        <TextField
            variant="standard"
            label="Enter mobile number"
            className={classes.textField}
            onChange={(e) =>
              setinitiatechat(e.target.value)
            }
          />
          
            <Button
            onClick={initiatechatwithcust}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Start Chat
          </Button>
           
          
          </FormGroup>
           <Grid container style={{ height: "80vh" }}>
      {/* Sidebar */}
      {chatData?(
      <Grid item xs={2} style={{ backgroundColor: "#f0f0f0", borderRight: "1px solid #ddd" }}>
        <Box style={{ padding: "10px" }}>
          <Typography variant="h6">Chats</Typography>
        </Box>
        <List>
      
          <ListItem >
            <Box>
            {chatData.map(c=>
              <div  className={"agent_read_flag" in c && c.agent_read_flag?classes.selectdiv:classes.selectdiv2}
        //       
              onClick={() => changechat(chatData.indexOf(c))} 
              >
              <Typography variant="subtitle1">{c.primary_mobile_number}</Typography>
              
              <Typography variant="body2" style={{  width:"10%", height: '30px', whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>
                {"messages" in c?c.messages[c.messages.length-1].content:""}
              </Typography>
              <hr style={{  width:"10%",float:"left"}}></hr>
              <br></br>
              
              </div>
            )}
             
            </Box>
          </ListItem>
        </List>
      </Grid>
    ):("")}
      {/* Chat Window */}
      {selectedchat?(
      <Grid item xs={10} style={{ display: "flex", flexDirection: "column" }}>
     
        <Box
          style={{
            padding: "10px",
            borderBottom: "1px solid #ddd",
            backgroundColor: "#fff",
          }}
        >
          <Typography variant="h6">{selectedchat.primary_mobile_number}</Typography>
        </Box>

 
        <Box
          style={{
            flex: 1,
            padding: "10px",
            overflowY: "auto",
            backgroundColor: "#e5ddd5",
            height: "600px", 
          }}
        
        >
        <div
        style={{
          
          overflowY: "auto",
       
          height: "800px", 
        }}
         id="scrollableDiv"
         ref={scrollableBoxRef}
        >
        {selectedchat.messages.map(c=>
        <div 
        style={{marginRight:"10px"}}
        >
        {c.content!==""?(<div>
          {c.sender_type=="customer"?(
            <Typography align="left" style={{ marginBottom: "10px", padding: "10px", background: "#fff", borderRadius: "10px", whiteSpace:"pre-wrap" }}>
            {c.content}
          </Typography>
          ):("")}
          
          {c.sender_type=="System"?(
            <Typography align="right" style={{ marginBottom: "10px", padding: "10px", background: "#dcf8c6", borderRadius: "10px", whiteSpace:"pre-wrap"  }}>
            {c.content}
          </Typography>
          ):("")}
          
          {c.sender_type.startsWith("Agent")?(
            <div>
           
            <Typography align="right" style={{ marginBottom: "10px", padding: "10px", background: "#dcf8c6", borderRadius: "10px", whiteSpace:"pre-wrap"  }}>
            {c.content}
          </Typography>
      
          </div>
          ):("")}
          </div>):(
            <div>
                        {"fileUrl" in c && c.fileUrl.length>0 && c.fileUrl.map((file, index) => (
                          <div key={index}>
                        {file.location.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                          <Typography style={c.sender_type=="customer"?{ marginBottom: "10px", padding: "10px", background: "#fff", borderRadius: "10px", whiteSpace:"pre-wrap" }:{ marginBottom: "10px", padding: "10px", background: "#dcf8c6", borderRadius: "10px", whiteSpace:"pre-wrap"  }}><a href={file.location} download target="_blank" rel="noreferrer"> <img className={classes.image} src={file.location} alt={file.name} title={file.name} />File</a></Typography>
                        
                        ) : (
                          <Typography style={c.sender_type=="customer"?{ marginBottom: "10px", padding: "10px", background: "#fff", borderRadius: "10px", whiteSpace:"pre-wrap" }:{ marginBottom: "10px", padding: "10px", background: "#dcf8c6", borderRadius: "10px", whiteSpace:"pre-wrap"  }}><a href={file.location} download><p>{file.name}</p></a></Typography>
                        )}
                      </div>
                        ))}
                      </div>
          )}
        </div>)}
        </div>
        <div ref={messagesEndRef} />
        </Box>

       
        <Box
          style={{
            padding: "10px",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
        >
          <TextField
            fullWidth
            multiline
            ref={inputRef}
            value={input}
            placeholder="Type a message"
            variant="outlined"
            size="small"
            style={{ marginRight: "10px" }}
            onChange={(e)=>setinput(e.target.value)}
          />
          <input
        type="file"
        multiple
        style={{ display: 'none' }}
        id="file-input"
        onChange={(e)=>handleFileInput2(e)}
      />
      <label htmlFor="file-input" style={{ cursor: 'pointer',  color: '#000000', padding: '10px', borderRadius: '5px', display: 'inline-block' }}><AttachFileIcon /></label>
          <IconButton color="primary" onClick={sendmessage} id="myButton">
            <SendIcon />
          </IconButton>
        </Box>
      </Grid>
    ):("")}
    </Grid>
       
        </Paper>
      );
}
 
export default Chat;